import React from 'react';

type TrashIconProps = {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
};

export const TrashIcon: React.FC<TrashIconProps> = ({
  color = '#8794AA',
  width = 16,
  height = 16,
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1964 5.22552C13.5962 5.24923 13.9001 5.57498 13.8754 5.95263L13.3859 13.3211L13.3851 13.3382C13.3654 13.611 13.3424 13.9204 13.2825 14.2095C13.22 14.511 13.1084 14.8401 12.875 15.1355C12.3782 15.7639 11.5404 16 10.4114 16H5.57902C4.44998 16 3.61225 15.7639 3.11545 15.1355C2.88191 14.84 2.76953 14.511 2.70701 14.2095C2.6471 13.9204 2.62499 13.611 2.60533 13.3382L2.60361 13.3168L2.11503 5.95263C2.09026 5.57498 2.39417 5.24922 2.79404 5.22552C3.19389 5.20201 3.53834 5.4896 3.56353 5.86729L4.05297 13.2281V13.2298C4.07432 13.5257 4.09195 13.7513 4.13225 13.9458C4.17128 14.1341 4.22271 14.2435 4.27873 14.3145C4.36152 14.4192 4.60807 14.6294 5.57902 14.6294H10.4114C11.3823 14.6294 11.6289 14.4192 11.7117 14.3145C11.7677 14.2435 11.8191 14.134 11.8582 13.9458C11.8985 13.7513 11.9161 13.5257 11.9374 13.2298V13.2281L12.4269 5.86729C12.4521 5.48955 12.7965 5.20194 13.1964 5.22552Z"
      fill={color}
    />
    <path
      d="M9.25241 10.6115C9.65315 10.6115 9.97779 10.9183 9.97795 11.2968C9.97795 11.6754 9.65326 11.9821 9.25241 11.9821H6.74575C6.34503 11.9819 6.02021 11.6753 6.02021 11.2968C6.02038 10.9184 6.34514 10.6116 6.74575 10.6115H9.25241Z"
      fill={color}
    />
    <path
      d="M9.87197 7.68253C10.2727 7.68258 10.5973 7.98935 10.5975 8.36783C10.5975 8.74644 10.2728 9.05307 9.87197 9.05313H6.1081C5.70738 9.05298 5.38256 8.74638 5.38256 8.36783C5.38273 7.98941 5.70748 7.68268 6.1081 7.68253H9.87197Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.98098 0C9.70958 1.63413e-05 10.314 0.156125 10.7121 0.601664C11.0452 0.974639 11.1239 1.45605 11.1723 1.75037C11.1749 1.76658 11.1775 1.78229 11.18 1.79731L11.3291 2.65671C12.5038 2.71813 13.678 2.80519 14.8482 2.91786C15.2469 2.95632 15.5368 3.2923 15.4962 3.66887C15.4555 4.04554 15.0997 4.32002 14.7009 4.28163C12.2183 4.04262 9.72118 3.91978 7.23261 3.91978C5.76758 3.91979 4.3017 3.99103 2.83626 4.13484L2.83454 4.13569L1.29901 4.28163C0.900326 4.31941 0.543875 4.04463 0.503669 3.66802C0.463701 3.29156 0.754877 2.95601 1.15338 2.91786L2.68719 2.77107C3.34638 2.70639 4.00636 2.65655 4.66563 2.62001L4.80954 1.78878C4.81262 1.77098 4.81573 1.75185 4.81901 1.73245C4.86959 1.43341 4.95112 0.952687 5.28433 0.585449C5.6855 0.143552 6.29132 8.05956e-05 7.00857 0H8.98098ZM7.00857 1.37145C6.73768 1.37149 6.57689 1.39931 6.48638 1.42778C6.4102 1.45183 6.39102 1.47391 6.38729 1.47813C6.3788 1.48753 6.35408 1.51837 6.32611 1.6087C6.29566 1.70719 6.27432 1.82728 6.24253 2.01067L6.14688 2.56027C6.5086 2.5518 6.87087 2.54833 7.23261 2.54833C8.10374 2.54833 8.97601 2.5643 9.84784 2.59356L9.74702 2.01408C9.71741 1.83763 9.69597 1.72054 9.66602 1.62321C9.63823 1.53304 9.61381 1.49875 9.60226 1.48581C9.59577 1.47856 9.57382 1.45479 9.49627 1.42949C9.40687 1.40041 9.24822 1.37146 8.98098 1.37145H7.00857Z"
      fill={color}
    />
  </svg>
);
